import { MoreOutlined } from "@ant-design/icons";
import {
  Dropdown,
  MenuProps,
  Space,
  Switch,
  TablePaginationConfig,
  Tooltip,
} from "antd";
import { Column, RecordCountBadge, Table } from "components";
import {
  StyledTableHeader,
  StyledTableWrapper,
} from "components/table/table.styled";
import dayjs from "dayjs";
import { DiscountCodeFilterFormPaginated } from "features/discount-code/components/filter-form/discount-code-filter-form/type";
import { useUpdateDiscountCodeStatus } from "features/discount-code/use-cases/status-update-discount-code";
import { usePermissions } from "features/users";
import { Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "routes/constants";
import { getRoute } from "routes/utils";
import { Notifications } from "types/notification";
type UsersWithWalletTableProps = {
  isLoading: boolean;
  data?: any;
  tableParams: DiscountCodeFilterFormPaginated;
  updateParams: Dispatch<SetStateAction<DiscountCodeFilterFormPaginated>>;
  refetch: () => void;
};

export const DiscountCodeTable = ({
  data,
  isLoading,
  tableParams,
  updateParams,
}: UsersWithWalletTableProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutate } = useUpdateDiscountCodeStatus();
  const permissions = usePermissions();

  // const { mutate: deleteMutate } = useDeleteNotification();

  if (!permissions) return null;
  const handleTableChange = (pagination: TablePaginationConfig) => {
    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
    });
  };

  // const handleDelete = (Id: string) => {
  //   const formData = {
  //     id: Id,
  //   };
  //   deleteMutate(formData, { onSuccess: refetch }); // Assuming mutate is defined elsewhere
  // };

  const items = (record: any): MenuProps["items"] => {
    const menuItems = [
      {
        label: "Edit",
        key: "0",
        onClick: () => {
          navigate(getRoute(ROUTES.DISCOUNT_CODE_EDIT, record.Id)); // Navigate to edit route
          document.body.style.overflow = "hidden";
        },
      },
      // {
      //   label: 'Delete',
      //   key: '1',
      //   // onClick: () => handleDelete(record.Id),
      // },
    ];

    return menuItems;
  };

  const handleUpdateStatus = (id: number, checked: boolean) => {
    mutate({ id: id, IsActive: checked });
  };

  return (
    <StyledTableWrapper>
      <StyledTableHeader>
        <RecordCountBadge
          text={"Coupon Codes Found"}
          count={data?.total || 0}
        />
      </StyledTableHeader>
      <Table<Notifications>
        loading={isLoading}
        dataSource={data?.items}
        rowKey="Id"
        onChange={handleTableChange}
        pagination={{
          current: tableParams.page,
          defaultPageSize: tableParams.size,
          total: data?.total,
        }}
      >
        <Column<Notifications>
          title={"Name"}
          dataIndex={"Title"}
          // width={screens.xxl ? 'auto' : 170}
        />

        <Column<Notifications> title={"Coupon"} dataIndex={"CouponCode"} />
        <Column<Notifications> title={"Coupon For"} dataIndex={"CouponFor"} />

        <Column<Notifications>
          // width={200}
          title={"Valid From"}
          dataIndex={"StartDate"}
          render={(_, record: any) => (
            <span>
              {record.StartDate && dayjs(record.StartDate).format("DD-MM-YYYY")}
            </span>
          )}
        />

        <Column<Notifications>
          // width={200}
          title={"Valid To"}
          dataIndex={"EndDate"}
          render={(_, record: any) => (
            <span>
              {record.EndDate && dayjs(record.EndDate).format("DD-MM-YYYY")}
            </span>
          )}
        />

        <Column<Notifications>
          title={"Discount Type"}
          dataIndex={"DiscountType"}
          ellipsis
          // width={screens.xxl ? 'auto' : 130}
        />
        <Column<Notifications> title={"Value"} dataIndex={"DiscountValue"} />

        <Column<Notifications>
          title={"Used/Total"}
          // dataIndex={'NoOfCoupons'}
          render={(_, record: any) => (
            <span>
              {record.TotalUsedCoupon}/{record.NoOfCoupons}
            </span>
          )}
        />

        <Column<Notifications>
          title={"Status"}
          dataIndex={"IsActive"}
          render={(_, record: any) => (
            <span>{record.IsActive ? "Active" : "InActive"}</span>
          )}
        />

        <Column<Notifications>
          // width={80}
          title={t("package.table.action")}
          dataIndex={"last_transaction_date"}
          // className='action_col'
          render={(_, record: any) => (
            <Space>
              <Tooltip title="Is Active">
                <Switch
                  defaultChecked={record.IsActive}
                  checked={record.IsActive}
                  onChange={(isChecked) => {
                    handleUpdateStatus(record.Id, isChecked);
                  }}
                />
              </Tooltip>
              <Dropdown menu={{ items: items(record) }} trigger={["click"]}>
                <Space className="dot_icon_drop" style={{ cursor: "pointer" }}>
                  <MoreOutlined style={{ fontWeight: "600" }} />
                </Space>
              </Dropdown>
            </Space>
          )}
        />
      </Table>
    </StyledTableWrapper>
  );
};
